import { makeChartComp } from '../../util/makeChartComp';
var AreaChart = makeChartComp('Area');
export default AreaChart;
